/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDistributionCenterMethods,
  DistributionCenterService,
  ICreateDistCenterMethods,
  CreateDistCenterService,
} from "./components";

export type DistributionCenterPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IDistributionCenterMethods &
  ICreateDistCenterMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new DistributionCenterService(),
    new CreateDistCenterService(),
  ];
};

export const getAgent = () => {
  return createAgent<DistributionCenterPageAgent>({
    plugins: getPlugins(),
  });
};
